<ng-container style="align-items: center;" *ngIf="visible && value!=null && value.srcData && !value.srcData.startsWith('[')">
    <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
        <img style="width: 100%; height: auto;" [src]="value.srcData | resolveUrl | async" loading="lazy" [height]="value.height" [width]="value.width" > 
    </div>
</ng-container>
<ng-container   *ngIf="visible && (value==null || !value.srcData || value.srcData.startsWith('['))">
    <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
    <img src="../../../../../../assets/images/noimage.png" loading="lazy" [height]="value.height" [width]="value.width">
</div>
</ng-container> 